import styles from "./HomepageTop.module.scss";
import Offlede from "./Offlede";
import Lede from "./Lede";
import TopStack from "./TopStack";
import UpperBelt from "./UpperBelt";
import DoubleWide from "./DoubleWide";
import StoryStrip from "./StoryStrip";
import HomepageTopInjectorDesktopAd from "../ads/HomepageTopInjectorDesktop";
import HomepageTopInjectorMobileAd from "../ads/HomepageTopInjectorMobile";

const HomepageTop = () => {
  return (
    <section className={styles.root}>
      <div className={styles.top}>
        <div className={styles.lede}>
          <Lede />
        </div>
        <HomepageTopInjectorMobileAd className={styles.mobileInjector} />
        <div className={styles.topStack}>
          <TopStack />
        </div>
        <div className={styles.offlede}>
          <Offlede />
        </div>
      </div>
      <HomepageTopInjectorDesktopAd className={styles.desktopInjector} />
      <div className={styles.upperBelt}>
        <UpperBelt />
      </div>
      <div className={styles.lowerBelt}>
        <div className={styles.doubleWide}>
          <DoubleWide />
        </div>
        <div className={styles.storyStrip}>
          <StoryStrip />
        </div>
      </div>
    </section>
  );
};

export default HomepageTop;
